const getFragment = (content) => {
    const fragment = document.createDocumentFragment();

    if (content instanceof HTMLElement) {
        fragment.appendChild(content.cloneNode(true))
    } else if (content instanceof Array) {
        content.forEach(cnt => {
            if (cnt instanceof HTMLElement) {
                fragment.appendChild(cnt.cloneNode(true))
            } else if (typeof cnt === 'string' || cnt instanceof String ) {
                [...elementFromString(cnt)].forEach(efs => fragment.appendChild(efs))
            }
        })
    } else if (typeof content === 'string' || content instanceof String ) {
        [...elementFromString(content)].forEach(efs => fragment.appendChild(efs))
    }
    return fragment;
}

const elementFromString = (str) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    if (doc.body.children.length) {
        return doc.body.children;
    } else {
        return doc.body.childNodes;
    }
}

export {getFragment, elementFromString};
